import PlatformDashboardTemplate from "../../templates/PlatformDashboardTemplate/PlatformDashboardTemplate";
import useFetch from "../../../hooks/useFetch";
import { platformDashboardRepository } from "../../../repository/platformDashboard.repository";
import { useEffect } from "react";
import { Loader } from "../../atoms/Loader/Loader";
import { useDocumentTitleLoading } from "../../../hooks/useDocumentTitle";
import {useCurrentRoute} from "../../../hooks/useCurrentRoute";
import {Routes} from "../../../routes";

const PlatformDashboard = () => {
  const currentRoute = useCurrentRoute(Routes.platformDashboard);

  useDocumentTitleLoading();

  const fetchPlatformDashboard = useFetch();
  useEffect(() => {
    if (!fetchPlatformDashboard.data) {
      fetchPlatformDashboard.fetchData(platformDashboardRepository.getPlatformDashboard());
    }
  }, []);

  const fetchInstructorStatistics = useFetch();
  useEffect(() => {
    if (currentRoute === Routes.platformDashboard.instructor && !fetchInstructorStatistics.data) {
      fetchInstructorStatistics.fetchData(platformDashboardRepository.getInstructorsStatistics());
    }
  }, [currentRoute]);

  return fetchPlatformDashboard.data ? (
    <PlatformDashboardTemplate platformData={fetchPlatformDashboard.data} instructorStatistics={fetchInstructorStatistics.data} />
  ) : (
    <Loader />
  );
};

export default PlatformDashboard;
